import { removeFrameFromFocusPresentation } from "@/lib/focus-frame-dismissal";
import { withMutationEmitSuppressed } from "@/lib/mirrored-store";

/**
 * Closing a transferred window must also retire its source Focus placeholder,
 * a transient chat's included. Every display applies the same floating
 * update, so each retires its own copy without broadcasting it.
 */
export function dismissFloatingFrameSource(frameId: string) {
  withMutationEmitSuppressed(() => {
    removeFrameFromFocusPresentation(frameId);
  });
}
